import { render } from "./SearchPatientNotFound.vue?vue&type=template&id=dcf48b2a&scoped=true"
import script from "./SearchPatientNotFound.vue?vue&type=script&lang=js"
export * from "./SearchPatientNotFound.vue?vue&type=script&lang=js"

import "./SearchPatientNotFound.vue?vue&type=style&index=0&id=dcf48b2a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcf48b2a"]])

export default __exports__